import { Col, Row } from 'antd';
import React from 'react'
import { TiFlash } from "react-icons/ti";

const taskNumbers = [1, 2, 3, 4, 5, 6, 7, 8];

function TaskCheckedList() {
  return (
    <div className='taskCheckedList'>
      <Row>
      <Col>
            {taskNumbers.map(() => {
              return (
                <Row gutter={[16, 0]} className="task-comments">
                  <Col>
                    <TiFlash size={16} />
                  </Col>
                  <Col>
                    <span>
                      <strong>aamir</strong> checked a <strong>task</strong>{" "}
                      "Evaluate move out".
                    </span>
                  </Col>
                  <Col>
                    <span>Aug 1 at 1:32am</span>
                  </Col>
                </Row>
              );
            })}
          </Col>
      </Row>
    </div>
  )
}

export default TaskCheckedList;
